import React from 'react';
import PropTypes from 'prop-types';
import styles from './Chip.module.scss';

/**
 * Chip component that renders a span with the content of the children property
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to be displayed inside the chip
 * @returns {JSX.Element} - Rendered component
 */
function Chip({ children }) {
  return <span className={styles.chip}>{children}</span>;
}

Chip.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Chip;
